import callAPiBase from './base';

const webhookApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/api/webhooks`,
      method: 'GET',
      useToken: true,
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/webhooks',
      method: 'POST',
      useToken: true,
      data,
    }),
  update: ({ ID, data }: { ID: string; data: object }) =>
    callAPiBase({
      endpoint: `/api/webhooks?id=${ID}`,
      method: 'PUT',
      useToken: true,
      data,
    }),
  delete: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/webhooks?id=${ID}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { webhookApi };
export default webhookApi;
